const router = [
    {
        path: '/intermediary',
        component: () => import('../views/Intermediary/Index.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    }
]
export default router
